import SecondaryButton from "components/Ui/Buttons/SecondaryButton"
import SingleSelect from "components/Ui/Form/SingleSelect"
import styled from "styled-components"

type StyledProps = {
  $operator: string
}

export const Conditions = styled.div`
  margin-bottom: 3rem;

  p {
    text-align: center;
  }
`

export const Tags = styled.div`
  margin-bottom: 5rem;
`
export const Actions = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-left: 1.2rem;
    cursor: pointer;
    fill: rgba(0, 0, 0, 0.6);
    transition: 0.2s;
    outline: none;
    width: 2rem;

    &:hover {
      fill: rgba(0, 0, 0, 1);
    }
  }
`
export const EmptyTags = styled.div`
  width: 70%;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  background: ${(p) => p.theme.colors.white};
  border-radius: 0.6rem;
  padding: 0.5rem 0;
  position: relative;
  margin-bottom: 1rem;
  margin: 0 auto;

  p {
    ${(p) => p.theme.bold};
  }
`

export const TagSelect = styled(SingleSelect)`
  margin: 1rem 0;
`

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`

export const AddTagRuleButton = styled(SecondaryButton)`
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  padding: 0.5rem 2rem;
  border-radius: 0.6rem;
  display: flex;
  align-items: center;
  margin-top: 2rem;
  justify-content: center;

  svg {
    margin-right: 1rem;
    width: 1.4rem;
    height: 1.4rem;
    fill: ${(p) => p.theme.colors.black};
  }

  /* &:hover {
    background: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.white};
    cursor: pointer;
    svg {
      fill: ${(p) => p.theme.colors.white};
    }
  } */
`

export const AddTagConditionButton = styled.button`
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 1.4rem;
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: absolute;
  left: 50%;
  margin-left: -1.4rem;
  cursor: pointer;
  transition: 0.2s;
  margin-top: 1rem;

  svg {
    width: 1.4rem;
    height: 1.4rem;
    fill: ${(p) => p.theme.colors.black};
  }

  ${(p) => p.theme.mQ.MEDIA_MIN_MEDIUM} {
    &:hover {
      background: ${(p) => p.theme.colors.turquoiseDark};
      border: 0.1rem solid ${(p) => p.theme.colors.turquoiseDark};

      svg {
        fill: ${(p) => p.theme.colors.white};
      }
    }
  }
`

export const OperatorsWrapper = styled.div`
  display: flex;
  justify-content: center;
`
export const OperatorButton = styled.button`
  height: 2.8rem;
  border-radius: 1.4rem;
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  cursor: pointer;
  transition: 0.2s;

  ${(p) => p.theme.mQ.MEDIA_MIN_MEDIUM} {
    &:hover {
      background: ${(p) => p.theme.colors.turquoiseDark};
      border: 0.1rem solid ${(p) => p.theme.colors.turquoiseDark};
    }
  }
`
export const TagWrapper = styled.div`
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  background: ${(p) => p.theme.colors.white};
  border-radius: 0.6rem;
  position: relative;
  margin: 1rem auto;
  padding: 1rem 0 5rem;
`

export const TagRuleTitle = styled.h3`
  margin: 1rem 3rem;
  display: flex;
  justify-content: space-between;
  svg {
    height: 2rem;
    &:hover {
      cursor: pointer;
    }
  }
`
export const TagRow = styled.div`
  width: 70%;
  margin: 1rem auto;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  background: ${(p) => p.theme.colors.white};
  border-radius: 0.6rem;

  &:last-of-type {
    margin-bottom: 1rem;
  }
`

export const TagHeader = styled.div`
  padding: 0.9rem 2rem;
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    width: 1.4rem;
    height: 1.4rem;
  }
`

export const TagKey = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  ${(p) => p.theme.bold};

  svg {
    margin-right: 0.6rem;
  }

  span {
    margin-right: 1rem;
  }
`

export const TagValues = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 1rem 2rem 2rem;
  background: ${p => p.theme.colors.background};
`

export const TagValue = styled.div`
  background: ${(p) => p.theme.colors.white};
  color: ${(p) => p.theme.colors.black};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  margin: 1rem 0.8rem 0 0;
  border-radius: 0.3rem;
  font-size: 1.3rem;
  ${(p) => p.theme.bold}
  display: inline-flex;
  align-items: center;
`

export const Label = styled.span`
  padding: 0 1rem;
`

export const RemoveTagValue = styled.span`
  border-left: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  background: ${(p) => p.theme.colors.greyLighter};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 0.7rem;
  cursor: pointer;

  svg {
    height: 1.2rem;
    width: 1.2rem;
    fill: ${(p) => p.theme.colors.black};
  }

  &:hover {
    background: ${(p) => p.theme.colors.greyLight};
  }
`

export const OperatorDiv = styled.div<StyledProps>`
  height: 0.3rem;
  width: 10rem;
  background: ${(p) => p.$operator === "or" ? p.theme.colors.yellow : "#dcf4e5"};
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  color: ${(p) => p.theme.colors.black};
  border-radius: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  position: relative;


  &:before {
    content: "";
    background: ${(p) => p.theme.colors.grey };
    display: inline-block;
    width: 0.1rem;
    position: absolute;
    height: 0.6rem;
    top:-1.1rem;
  }

  &:after {
    content: "";
    background: ${(p) => p.theme.colors.grey };
    display: inline-block;
    width: 0.1rem;
    position: absolute;
    height: 0.6rem;
    bottom: -1.1rem;
  }

  span {
    font-weight: 700;
  }
`
